import React from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@mantis-sas/ui";
import { ChevronRight, Home } from "lucide-react";
import { motion } from "framer-motion";

export default function Breadcrumbs({ items, onNavigate }) {
  const handleClick = (item, e) => {
    if (item.href && item.href !== '#' && onNavigate) {
      e.preventDefault();
      onNavigate(item.href, item);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Breadcrumb className="mb-6">
        <BreadcrumbList className="flex items-center space-x-2">
          {items.map((item, index) => (
            <React.Fragment key={index}>
              <BreadcrumbItem>
                {index === items.length - 1 ? (
                  <BreadcrumbPage className="text-slate-900 dark:text-slate-100 font-semibold">
                    {index === 0 && (
                      <Home className="h-4 w-4 mr-2 inline" />
                    )}
                    {item.label}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink 
                    href={item.href}
                    onClick={(e) => handleClick(item, e)}
                    className="text-slate-600 dark:text-slate-400 hover:text-orange-600 dark:hover:text-orange-400 transition-colors duration-200 font-medium cursor-pointer"
                  >
                    {index === 0 && (
                      <Home className="h-4 w-4 mr-2 inline" />
                    )}
                    {item.label}
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {index < items.length - 1 && (
                <BreadcrumbSeparator>
                  <ChevronRight className="h-4 w-4 text-slate-400" />
                </BreadcrumbSeparator>
              )}
            </React.Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </motion.div>
  );
} 